module.exports = __webpack_public_path__ + "img/eye.5423c104.svg";